module.exports = __webpack_public_path__ + "public/MoreSection/1.jpg?04ba463e";